import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { NavbarLog } from '../../navbar/NavbarLog';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText } from 'reactstrap';
//import "./Carrera.css";
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

//Rutas de consulta en el backend
const UrlListarPlanes = ApiUrl + "listarplanes" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlInsertarPlan = ApiUrl + "insertarplan" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 4;

export default class GestionPlanes extends Component {

    constructor(props) {
        super(props)

        this.state = {
            pagina: 0,
            planes: [],
            modalReportIngresarPlan: false,
            //nuevas variables
            listaplanes: [],
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
    }

    handleChangeListarPlanes = async (e) => {
        //planes
        axios.get(UrlListarPlanes)
            .then(respuesta => {
                const planes = respuesta.data.data;
                this.setState({ planes });
                this.setState({ listaplanes: planes });
                listaauxiliar = this.state.listaplanes;

                //PAGINACION
                this.state.itemOffset = 0;
                const endOffset = this.state.itemOffset + itemsPerPage;
                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });

                this.setState((state) => {
                    return { itemOffset: state.itemOffset + endOffset }
                });
            })
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        this.handleChangeListarPlanes();
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        this.setState({ pagina: event.selected });
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            // Importante: lee state en vez de this.state al actualizar.
            return { itemOffset: newOffset }
        });
    }
    //FIN DE PAGINACION

    mostrarModalIngresar = () => {
        this.setState({ id: 0 });
        this.setState({ modalReportIngresarPlan: true });
    }

    mostrarModalModificar = (registro) => {
        $(function () {
            $("#id").val(registro.id_plan);
            $("#nombre").val(registro.nombre_plan);
            $("#fechainicio").val(registro.fechainicio_plan);
            $("#fechafin").val(registro.fechafin_plan);
            $("#estadoplan").val(registro.estado_plan);
        });

        this.setState({ id: registro.id_plan });
        this.setState({ nombre: registro.nombre_plan });
        this.setState({ fechainicio: registro.fechainicio_plan });
        this.setState({ fechafin: registro.fechafin_plan });
        this.setState({ estadoplan: registro.estado_plan });
        this.setState({ modalReportIngresarPlan: true });
    }

    ocultarModalIngresar = () => {
        this.setState({ modalReportIngresarPlan: false });
    }

    registrarPlan = () => {

        const f = new FormData();
        f.append("id", this.state.id);
        f.append("nombre", this.state.nombre);
        f.append("fechainicio", this.state.fechainicio);
        f.append("fechafin", this.state.fechafin);
        f.append("estadoplan", this.state.estadoplan);

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        axios.post(urlInsertarPlan, f, {

        }, config)
            .then(response => {
                if (response.data.success === true) {
                    swal({
                        text: "Operación Exitosa!!",
                        icon: "success",
                        button: "Aceptar",
                    });
                    axios.get(UrlListarPlanes)
                        .then(respuesta => {
                            const planes = respuesta.data.data;
                            this.setState({ planes });
                            this.setState({ listaplanes: planes });
                            listaauxiliar = this.state.listaplanes;

                            if (this.state.pageCount == 1) {
                                this.setState({ itemOffset: 0 });
                            }
                            
                            //PAGINACION
                            const newOffset = (this.state.pagina * itemsPerPage) % listaauxiliar.length;
                            this.setState((state) => {
                                return { itemOffset: newOffset }
                            });
                            const endOffset = newOffset + itemsPerPage;
                            //const endOffset = (this.state.pageCount * itemsPerPage) % listaauxiliar.length;
                            this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                            this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                            this.setState({ itemOffset: newOffset });
                        })
                    this.ocultarModalIngresar();
                }
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">{this.state.estado}</li>
                </ol>
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="card-header back-istmas">
                        <i className="far fa-sticky-note"></i>
                        <b> Gestión de Planes</b>
                    </div>
                    <div className="card border-dark text-center ">
                        <div className="card-header ">
                            <b>REPORTE DE PLANES</b>
                        </div>
                        <div class="table-responsive">
                            <table className="table table-bordered" id="tablaasignaturas" name="tablaasignaturas" width="100%" >
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nombre</th>
                                        <th>Fecha Inicio</th>
                                        <th>Fecha de Fin</th>
                                        <th>Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.currentItems && this.state.currentItems.map((consola) => (
                                        <tr key={consola.id_plan}>
                                            <td class="id">{consola.id_plan}</td>
                                            <td class="nombre">{consola.nombre_plan}</td>
                                            <td class="f_inicio">{consola.fechainicio_plan}</td>
                                            <td class="f_fin">{consola.fechafin_plan}</td>
                                            {(() => {
                                                if (consola.estado_plan == "En proceso") {
                                                    return <td class="estadoplan table-primary">{consola.estado_plan}</td>
                                                }
                                                if (consola.estado_plan == "Completado") {
                                                    return <td class="estadoplan table-success">{consola.estado_plan}</td>
                                                }
                                                if (consola.estado_plan == "Inactivo") {
                                                    return <td class="estadoplan table-danger">{consola.estado_plan}</td>
                                                }
                                            })()}
                                            <td class="detalle">
                                                <button onClick={() => this.mostrarModalModificar(consola)} > <i className=" fas fa-clipboard-list" ></i></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div class="table-responsive">
                                <ReactPaginate
                                    nextLabel="next >"
                                    onPageChange={this.handlePageClick}
                                    pageRangeDisplayed={5}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={2}
                                    previousLabel="< previous"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakLabel="..."
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    containerClassName="pagination"
                                    activeClassName="active"
                                    renderOnZeroPageCount={null}
                                />
                            </div>
                            <Modal isOpen={this.state.modalReportIngresarPlan} >
                                <ModalHeader>
                                    Registro de Plan
                                </ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <div className="mb-3 centrar">
                                            <input type="hidden" name="id" class="id" id="id" value="" />
                                            <label className="form-label">Nombre:</label>
                                            <input type="text" id="nombre" name="nombre" onChange={this.handleChange} className="form-control" placeholder="" autocomplete="off" required />
                                            <label className="form-label">Fecha Inicio:</label>
                                            <input type="date" id="fechainicio" name="fechainicio" onChange={this.handleChange} className="form-control" placeholder="" autocomplete="off" required />
                                            <label className="form-label">Fecha Fin:</label>
                                            <input type="date" id="fechafin" name="fechafin" onChange={this.handleChange} className="form-control" placeholder="" autocomplete="off" required />
                                            <label className="form-label">Estado:</label>
                                            <select className="form-select" id="estadoplan" name="estadoplan" value={this.state.value} onChange={this.handleChange} aria-label="Default select example" autocomplete="off" required>
                                                <option value="">Seleccione</option>
                                                <option value="En proceso">En proceso</option>
                                                <option value="Completado">Completado</option>
                                                <option value="Inactivo">Inactivo</option>
                                            </select>
                                        </div>
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>

                                    <button class="btn btn-outline-primary" onClick={() => this.registrarPlan()} > Ingresar</button>
                                    <button class="btn btn-outline-primary" onClick={() => this.ocultarModalIngresar()}>Salir</button>

                                </ModalFooter>
                            </Modal>
                            <div className="text-center">
                                <button id="agregar" type="button"
                                    className="btn  back-istmas centrar"
                                    style={{ margin: "5px", width: "170px" }}
                                    onClick={() => this.mostrarModalIngresar()} >
                                    <b>Registrar</b>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

